import React from 'react';
import PropTypes from 'prop-types';
import { Tile, HeadingText } from '@paypalcorp/pp-react';
import Illustration from '../../components/illustrations/Illustration';
import ReturnToMerchantLink from '../../components/returnToMerchant';

const ReceiverEligibilityErrorTile = ({
  errorMessages,
  organizationName,
  returnUrl,
}) => {
  const {
    error: { receiveDonationNotAllowed } = {},
    label: { returnTo } = {},
  } = ({} = errorMessages);

  return (
    <Tile
      className="receiver-eligibility-error-tile"
      data-testid="receiver-eligibility-error-tile"
    >
      <Illustration type="warning" size="medium" />
      <HeadingText size="lg">{receiveDonationNotAllowed}</HeadingText>
      {returnUrl && (
        <ReturnToMerchantLink
          returnLabel={returnTo}
          organizationName={organizationName}
          returnUrl={returnUrl}
        />
      )}
    </Tile>
  );
};

ReceiverEligibilityErrorTile.propTypes = {
  errorMessages: PropTypes.object,
  organizationName: PropTypes.string,
  returnUrl: PropTypes.string,
};

export default ReceiverEligibilityErrorTile;
